// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var ctaLine = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(28)),
      BsCssJs$PrezzeeRibbon.selector("button", [
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.em(1))),
            BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.em(1)))
          ]),
      BsCssJs$PrezzeeRibbon.children([
            BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.px(16)),
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.px(223))
          ]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [
            BsCssJs$PrezzeeRibbon.display("flex"),
            BsCssJs$PrezzeeRibbon.flexWrap("wrap"),
            BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(22)),
            BsCssJs$PrezzeeRibbon.children([
                  BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.px(12)),
                  BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.px(195))
                ]),
            BsCssJs$PrezzeeRibbon.lastChild([BsCssJs$PrezzeeRibbon.marginRight("zero")])
          ]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mobile, [
            BsCssJs$PrezzeeRibbon.children([BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.px(12))]),
            BsCssJs$PrezzeeRibbon.lastChild([BsCssJs$PrezzeeRibbon.marginBottom("zero")])
          ])
    ]);

var Styles = {
  ctaLine: ctaLine
};

function TheGiftExperience__CTA(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    ctaLine,
                    className$1
                  ])
            });
}

var make = TheGiftExperience__CTA;

export {
  Styles ,
  make ,
}
/* ctaLine Not a pure module */
